import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Http, Headers, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { UserService } from '../api/user.service';

@Injectable()
export class MoveCheck implements CanActivate {
  constructor(private router: Router, private http: Http, private userService: UserService) {}

  canActivate() {

    if (this.userService.getUsername() == null && this.userService.getProfileUrl() == null) {
      this.userService.setUserInfo();
    }

    if (this.router.url === '/sign/make' || this.router.url === '/sign/list' || this.router.url === '/poster/list') {
      $('#modalClose').click();
    }

    return true;
  }

   /**
  * 헤더 설정 ( session storage )
  */
  getHeadersFromSession() {
    const headers = new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')});
    return headers;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/guard/move.check.ts